"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    border-radius: ", "em;\n    border: 1px solid ", ";\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    padding: 0 ", "em;\n    margin: 0\n        ", "\n        auto ", "em;\n    font-size: 1em;\n    margin-bottom: ", "em;\n"], ["\n    width: 100%;\n    border-radius: ", "em;\n    border: 1px solid ", ";\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    padding: 0 ", "em;\n    margin: 0\n        ", "\n        auto ", "em;\n    font-size: 1em;\n    margin-bottom: ", "em;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../functions");

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTextarea = _styledComponents2.default.textarea(_templateObject, function (props) {
    return props.theme.input.radius;
}, function (props) {
    return props.theme.input.borderColor;
}, function (props) {
    return props.theme.input.sizes[props.size] / 4;
}, function (props) {
    return props.expanded || props.align == "right" ? 0 : "0.4em";
}, function (props) {
    return props.align == "right" ? "0.4em" : 0;
}, function (props) {
    return props.theme.input.margin;
});

var TextareaField = function TextareaField(_ref) {
    var name = _ref.name,
        onChange = _ref.onChange,
        label = _ref.label,
        readOnly = _ref.readOnly,
        rows = _ref.rows,
        columns = _ref.columns,
        error = _ref.error,
        rest = _objectWithoutProperties(_ref, ["name", "onChange", "label", "readOnly", "rows", "columns", "error"]);

    var fieldOptions = {};

    if (readOnly) {
        fieldOptions["readOnly"] = "readOnly";
    }
    var handleChange = function handleChange(event) {
        onChange({
            name: name,
            value: event.target.value
        });
    };

    return _react2.default.createElement(
        "div",
        null,
        label && _react2.default.createElement(
            _label2.default,
            _extends({ name: name, label: label }, rest),
            label
        ),
        _react2.default.createElement(StyledTextarea, _extends({
            rows: rows,
            cols: columns,
            onChange: handleChange
        }, fieldOptions, rest)),
        _react2.default.createElement(_inputError2.default, { error: error })
    );
};

TextareaField.displayName = "TextareaField";

TextareaField.propTypes = {
    name: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    size: _propTypes2.default.string,
    expanded: _propTypes2.default.bool,
    inlineLabel: _propTypes2.default.bool,
    input: _propTypes2.default.object,
    rows: _propTypes2.default.number,
    columns: _propTypes2.default.number,
    label: _propTypes2.default.string,
    readOnly: _propTypes2.default.bool,
    error: _propTypes2.default.string
};
TextareaField.defaultProps = {
    size: "default",
    expanded: false,
    inlineLabel: true,
    rows: 6,
    columns: 20,
    type: "text",
    readOnly: false,
    error: ""
};
exports.default = TextareaField;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/textarea.js
// module id = 1008
// module chunks = 95715928098905 168707334958949